import React from 'react';
import _ from 'lodash';

import { OrderProduct } from '../../../../../../api-client';
import { IShoppingDateGroup } from '../../../../../models/Shopping';
import { orderTotalByProducts } from '../../../../../../utils/data-format-enchanters/order-products-enchanter';

import './bv-shopping-date-group.scss';

import BVDeliveryGroup from './components/BVDeliveryGroup/bv-delivery-group';

interface IBVShoppingDateGroup {
    disabled: boolean;
    shoppingDateGroup: IShoppingDateGroup;
}

const BVShoppingDateGroup: React.FunctionComponent<IBVShoppingDateGroup> = ({ disabled, shoppingDateGroup }) => {
    const _handleDateGroupProducts = () => {
        let dateGroupProducts: OrderProduct[] = [];

        _.forEach(_.map(shoppingDateGroup.deliveryDates, delivery => delivery.products), deliveryProducts => (
            dateGroupProducts = [
                ...dateGroupProducts,
                ...deliveryProducts || []
            ]
        ));

        return dateGroupProducts;
    }

    return (
        <div className="bv-shopping-date-group-container">
            <div className="shopping-date-group shopping-address-group">
                {shoppingDateGroup.name}

                <span>{`${shoppingDateGroup.address}, ${shoppingDateGroup.city}`}</span>
            </div>

            <div className="shopping-date-group shopping-total-group">
                {orderTotalByProducts(_handleDateGroupProducts()).amountFormat}
            </div>

            {_.map(shoppingDateGroup.deliveryDates, (dataItem, dataIndex) => (
                <BVDeliveryGroup
                    key={dataIndex}
                    customerFacilityId={shoppingDateGroup.id || -1}
                    deliveryGroup={dataItem}
                    disabled={disabled}
                />
            ))}
        </div>
    );
}

export default BVShoppingDateGroup;